import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, db } from './firebase-config';
import { doc, setDoc } from 'firebase/firestore';
import './FormStyles.css';

const EmployerSetup = () => {
  const [formData, setFormData] = useState({
    companyName: '',
    industry: '',
    companySize: '',
    location: '',
    website: '',
    description: ''
  });
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const user = auth.currentUser;
    if (user) {
      try {
        await setDoc(doc(db, 'employers', user.uid), {
          ...formData,
          email: user.email,
          profilePic: 'https://via.placeholder.com/40'
        });
        window.location.href = '/job-feed';
      } catch (error) {
        console.error('Error saving employer data:', error);
        alert('There was an error saving your profile. Please try again.');
      }
    }
  };

  return (
    <div className="setup-container">
      <div className="setup-card">
        <div className="setup-header">
          <button onClick={() => navigate(-1)} className="back-button">
            ←
          </button>
          <h2 className="setup-title">Complete Company Profile</h2>
        </div>
        <form onSubmit={handleSubmit} className="setup-form">
          {Object.entries(formData).map(([key, value]) => (
            <div className="form-group" key={key}>
              <label htmlFor={key}>
                {key === 'companyName' ? 'Company Name' :
                 key === 'companySize' ? 'Company Size' :
                 key.charAt(0).toUpperCase() + key.slice(1)}
              </label>
              {key === 'description' ? (
                <textarea
                  id={key}
                  name={key}
                  className="form-input"
                  value={value}
                  onChange={handleChange}
                  required={key !== 'website'}
                  placeholder={`Enter company ${key.toLowerCase()}`}
                />
              ) : (
                <input
                  type="text"
                  id={key}
                  name={key}
                  className="form-input"
                  value={value}
                  onChange={handleChange}
                  required={key !== 'website'}
                  placeholder={`Enter company ${key.toLowerCase()}`}
                />
              )}
            </div>
          ))}
          <button type="submit" className="submit-btn">Complete Setup</button>
        </form>
      </div>
    </div>
  );
};

export default EmployerSetup;
